import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact";
import { useState, useRef, useEffect } from "preact/hooks";
import { productImagePlaceholder } from "../helpers";
import SubmitButton from "./elements/SubmitButton";

const extractUniqueSwatches = (isSaleSku, skus = []) => {
    if (!Array.isArray(skus)) {
        console.error('Expected an array of SKUs but got:', skus);
        return [];
    }
    const uniqueSwatches = new Map();
    skus.forEach(({ customFields, imageUrl, price, listPrice }) => {
        const hexField = customFields.find(({ key }) => key === 'custom-hex_code');
        // const currentSaleStatus = customFields.find(({ key }) => key === 'custom-sale_product');
        const currentSaleStatus = listPrice && listPrice > price

        // if (currentSaleStatus?.value === "false" && isSaleSku) return;  // Show only sale swatches on sale pages
        // if (currentSaleStatus?.value === "true" && !isSaleSku) return; // Show only non-sale swatches on non-sale pages
        if (!currentSaleStatus && isSaleSku) return;  // Show only sale swatches on sale pages
        if (currentSaleStatus && !isSaleSku) return; // Show only non-sale swatches on non-sale pages

        if (hexField && !uniqueSwatches.has(hexField.value)) {
            uniqueSwatches.set(hexField.value, imageUrl);
        }
    });
    return Array.from(uniqueSwatches.entries());
};

export default function Autocomplete() {
    const { products, keywords } = useResponse();
    const [isOpen, setIsOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { format } = useCurrencyFormatting();
    let topOffset = 0

    const headerElements = document.querySelectorAll('.shopify-section-group-header-group')
    headerElements.forEach(element => {topOffset += element.offsetHeight} )

    if(window.innerWidth > 1023){
        topOffset = 124
    }

    // const handleKeywordClick = (keyword) => {
    //     window.location.href = `https://lifeisgood-prod.myshopify.com/?q=${encodeURIComponent(keyword)}`;
    // };

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const inputField = document.querySelector("input#search-input");

        // const handleInput = (event) => setIsOpen(!!event.target.value);
        const openAutocomplete = () => {setIsOpen(true); document.body.classList.add('ns-block-scroll')}
            
        const handleKeyPress = (event) => {
            if (event.key === "Enter") {
                setIsOpen(false);
                inputField.blur();
            }
        };

        // inputField?.addEventListener("input", handleInput);
        inputField?.addEventListener("keypress", handleKeyPress);
        inputField?.addEventListener("click", openAutocomplete);

        return () => {
            inputField?.removeEventListener("input", handleInput);
            inputField?.removeEventListener("keypress", handleKeyPress);
        };
    }, []);

    useEffect(() => {
        const resetOverflow = () => document.body.classList.remove('ns-block-scroll');

        if (isOpen) {
            // document.body.style.overflow = "hidden";
            document.body.classList.add('ns-block-scroll')
        } else {
            resetOverflow();
        }

        return resetOverflow;
    }, [isOpen]);

    const closeAutocomplete = () => setIsOpen(false);

    const hasProducts = products?.hits?.length > 0;
    const hasKeywords = keywords?.hits?.length > 0;

    useEffect(() => {
        nostojs(api => api
            .createRecommendationRequest({ includeTagging: true })
            .setElements(['searchdropdown-nosto-empty'])
            .loadRecommendations({ skipPageViews: true }).then(() => {
                document.querySelector("#searchdropdown-nosto-empty .close-btn")?.addEventListener("click", () => {
                    closeAutocomplete();
                })
            }));
    }, [isOpen && !hasProducts]);

    const AutocompleteElementContent = ({ hit, isMobile }) => {
        const [hoverImage, setHoverImage] = useState(null);
        const sliderRef = useRef(null);
        const [isDown, setIsDown] = useState(false);
        const [startX, setStartX] = useState(0);
        const [scrollLeft, setScrollLeft] = useState(0);
        
        

        const handleMouseDown = (e) => {
            if (!sliderRef.current) return;
            setIsDown(true);
            setStartX(e.pageX - sliderRef.current.offsetLeft);
            setScrollLeft(sliderRef.current.scrollLeft);
        };

        const handleMouseMove = (e) => {
            if (!isDown || !sliderRef.current) return;
            e.preventDefault();
            const x = e.pageX - sliderRef.current.offsetLeft;
            const walk = (x - startX) * 5;
            sliderRef.current.scrollLeft = scrollLeft - walk;
        };

        // const isSaleSku = hit?.skus?.length > 0 && hit?.skus[0]?.customFields?.find(field => field.key === 'custom-sale_product')?.value == "true" ? true : false;
        
        const isSaleSku = hit?.skus?.length > 0 && hit?.skus[0].listPrice && hit?.skus[0].listPrice > hit?.skus[0].price;
        const swatches = extractUniqueSwatches(isSaleSku, hit.skus);
        const [firstWord, ...restWords] = hit.name.split(" ");
        const productName = restWords.join(" ");

        const genderedCategories = ["Men's", "Women's", "Kids", "Boys", "Girls", "Toddler", "Infant"]

        const handleSwatchAction = (imageUrl) => isMobile && setHoverImage(imageUrl);

        let bestsellingSku = hit.skus?.find(sku => (sku.customFields?.find(field => field.key === 'custom-bestseller')?.value === 'true' && sku.customFields?.find(field => field.key === 'custom-sale_product')?.value !== 'true'))
    if(isSaleSku) { 
        bestsellingSku = hit.skus?.find(sku => (sku.customFields?.find(field => field.key === 'custom-bestseller')?.value === 'true' && sku.customFields?.find(field => field.key === 'custom-sale_product')?.value === 'true'))
    }

        // Sale vs Non-sale Logic - Swatches and Images
        let prodUrl = hit.url;
        // let listPrice = hit.listPrice,
        //     paidPrice = hit.price,
        //     // mainImg = hit.imageUrl,
        //     mainImg = hit.skus[0].imageUrl ? hit.skus[0].imageUrl : hit.imageUrl,
         let listPrice = bestsellingSku?.listPrice ? bestsellingSku.listPrice : hit.listPrice,
        paidPrice = bestsellingSku?.price ? bestsellingSku.price : hit.price,
        mainImg = bestsellingSku?.imageUrl ? bestsellingSku.imageUrl : hit.skus[0].imageUrl ? hit.skus[0].imageUrl : hit.imageUrl,
            altImg = mainImg;
        if(hit.alternateImageUrls && hit.alternateImageUrls[0] != "") { altImg = hit.alternateImageUrls[0] } 
        
        if(isSaleSku) { 
            hit.url = hit.url + "?sale_value=true"
            hit.skus?.some(function(el) {
                if(el.price < el.listPrice){
                    // listPrice = el.listPrice;
                    // paidPrice = el.price;
                    // mainImg = el.imageUrl,
                    listPrice = bestsellingSku?.listPrice ? bestsellingSku.listPrice : el.listPrice;
                    paidPrice = bestsellingSku?.price ? bestsellingSku.price : el.price;
                    mainImg = bestsellingSku?.imageUrl ? bestsellingSku.imageUrl : el.imageUrl;
                    hit.alternateImageUrls?.some(function(innerEl, idx) {
                        if(innerEl == mainImg) {
                            altImg = hit.alternateImageUrls[idx + 1];
                            // setHoverImage(null);
                            return true;
                        }
                    })
                    return true;
                }
            })
        }

        return (
            <div class="ns-ac-product relative" data-nosto-element="product">
                <div class="ns-product-ac-image-container">
                    { hit.tags1?.includes("is_customizable::True") && (
                        <button 
                            data-gan={hit.customFields.find(field => field.key === 'custom-gan').value} 
                            data-is-kids-graphic={hit.tags1.includes("is_kids_graphic::True")} 
                            data-is-hoodie-graphic={hit.tags1.includes("is_hoodie_graphic::True")}
                            data-is-tank-graphic={hit.tags1.includes("is_tank_graphic::True")}
                            class="right-[5px] top-[5px] customizer-button body-12-med hover:bg-grey-6 ">
                                <span class="customizer-button-text">Customize</span>
                                <img srcset="" sizes=", undefinedpx" src="https://cdn.shopify.com/s/files/1/0686/8326/8417/files/customizer-icon.png?v=1728055689" alt="Customize this product" height="12" width="12" loading="lazy" class="image customizer-button-image w-[12px] block object-fit " />
                        </button>
                    )}
                    <div class="ns-badges-container">
                        {paidPrice < listPrice && (
                            <span class="ns-sale-badge">On Sale!</span>
                        )}
                        {hit.tags1?.includes("badge::new") && (
                            <span class="ns-new-badge">New!</span>
                        )}
                    </div>
                    <img
                        className="ns-ac-image"
                        src={`${hoverImage || mainImg || productImagePlaceholder}&width=400`}
                        alt={`Product image for "${hit.name}" ||${ hoverImage?.substring(hoverImage?.lastIndexOf('/') + 1, hoverImage?.indexOf('.jpg')) || mainImg?.substring(mainImg?.lastIndexOf('/') + 1, mainImg?.indexOf('.jpg')) || ''} `}
                        width="60"
                        height="40"
                    />
                </div>

                {swatches.length > 0 && (
                    <div class="ns-swatches-container" onClick={(e)=>e.stopPropagation()}>
                        <div
                            class="ns-swatches-inner"
                            onMouseDown={handleMouseDown}
                            onMouseLeave={() => setIsDown(false)}
                            onMouseUp={() => setIsDown(false)}
                            onMouseMove={handleMouseMove}
                            ref={sliderRef}
                        >
                            <div class="ns-swatches">
                                {swatches.map(([hexCode, imageUrl], index) => (
                                    <span
                                        key={index}
                                        // class="ns-swatch-item"
                                        class={`ns-swatch-item ${imageUrl === bestsellingSku?.imageUrl ? 'ns-bestselling-swatch' : ''}`}
                                        style={{ backgroundColor: hexCode }}
                                        onMouseEnter={() => !isMobile && setHoverImage(imageUrl)}
                                        onClick={() => setHoverImage(imageUrl)}
                                        onMouseLeave={() => !isMobile && setHoverImage(null)}
                                        // onTouchEnd={() => isMobile && setHoverImage(null)}
                                    ></span>
                                ))}
                            </div>
                        </div>
                        {((!isMobile && swatches.length > 6) || (isMobile && swatches.length > 4)) && (
                            <span class="ns-more-swatches"
                                  onClick={(e) => { e.currentTarget.closest(".ns-swatches-container").classList.toggle("showSwatches") }}>
                                <svg width="15" height="12" viewBox="0 0 15 12" fill="none">
                                    <path d="M5 1L11 6L5 11" stroke="#0A4875" strokeLinecap="round" />
                                </svg>
                            </span>
                        )}
                    </div>
                )}

                <div class="ns-product-info">
                    {/* <div class="ns-product-category">{firstWord}</div> */}
                    <div class="ns-product-category">
                        <span class={`${!genderedCategories.includes(firstWord) ? 'ns-transparent' : ''}`}>{firstWord}</span>
                        {/* {!hit.brand.toLowerCase() === 'life is good' ? 
                            <span>{hit.brand}</span>
                            :
                            hit.customFields?.find(field => field.key === 'custom-department').value === 'Accessories' ?
                            <span>{hit.customFields?.find(field => field.key === 'custom-style_category').value}</span>
                            :
                            <span class={`${!genderedCategories.includes(firstWord) ? 'ns-transparent' : ''}`}>{firstWord}</span>                                
                        } */}
                        {/* {hit.brand.toLowerCase() === 'life is good' ? 
                            <span class={`${!genderedCategories.includes(firstWord) ? 'ns-transparent' : ''}`}>{firstWord}</span>
                        :
                            <span>{hit.brand}</span>
                        } */}
                    </div>
                    <div class="ns-product-name">
                        {/* {!hit.brand.toLowerCase() === 'life is good' ? 
                        hit.name.replace(hit.brand, '') 
                        : 
                        hit.customFields?.find(field => field.key === 'custom-department').value === 'Accessories' ? 
                        hit.name.replace('Adult Unisex', '') 
                        : 
                        productName
                        } */}
                        {/* {hit.brand.toLowerCase() === 'life is good' ? productName : hit.name.replace(hit.brand, '')} */}
                        {
                                    genderedCategories.includes(firstWord) ? 
                                    hit.name.replace(firstWord, '') :
                                    hit.name}
                        </div>
                </div>

                <div class="ns-price-container">
                    {listPrice > paidPrice && (
                        <span class="ns-old-price">{format(listPrice)}</span>
                    )}
                    <span class={hit.tags1.includes("is_bundle::True") ? "ns-compare-at-price" : paidPrice < listPrice ? "ns-discounted-price" : "ns-regular-price"}>
                        {format(paidPrice)}
                    </span>
                    {(hit.tags1.includes("is_bundle::True") && hit.tags1.some(tag => tag.includes('bundle_MSRP::'))) && (
                        <span class="ns-msrp-price" style={{opacity: 0.5, textDecoration: 'line-through', marginLeft: '5px'}}>{format(+hit.tags1.find(tag => tag.includes('bundle_MSRP::')).substring(hit.tags1.find(tag => tag.includes('bundle_MSRP::')).indexOf('::') + 3))}</span>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div
            class={`ns-autocomplete ns-autocomplete-container ${isOpen ? "ns-ac-open" : "ns-ac-closed"}`}
            data-nosto-element="autocomplete"
            style={`top: ${topOffset - 20}px`}
        >
            <div class="ns-autocomplete-inner" 
            // style={`height: calc(100vh - ${topOffset - 20}px)`}
            >
                {hasProducts || hasKeywords ? (
                    <div class="ns-autocomplete-alignment">
                        <div class="ns-keywords-container">
                            <div class="ns-ac-text h5">Search Suggestions</div>
                            { isOpen && (
                                <span class="close-btn h5" onClick={closeAutocomplete}>X</span>
                            )}
                            {hasKeywords && (
                                <div class="ns-keywords-inner">
                                    <Keywords
                                        hits={keywords.hits}
                                        keywordComponent={Keyword}
                                        elementComponent={Element}
                                        keywordInCategoryComponent={KeywordInCategory}
                                    />
                                    {/* {keywords.hits.map((item, index) => (
                                        <span class="ns-keyword-item" 
                                        onClick={() => handleKeywordClick(item.keyword)}
                                        key={index}>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: item._highlight.keyword
                                                        .replace(/<strong>/g, '<span class="ns-highlighted-part">')
                                                        .replace(/<\/strong>/g, "</span>")
                                                }}
                                            />
                                        </span>
                                    ))} */}
                                </div>
                            )}
                        </div>

                        {hasProducts && (
                            <div class="ns-ac-products-container">
                                <div class="ns-ac-product-header h5">
                                    <span class="ns-ac-text">Top Suggestions</span>
                                    <SubmitButton text="View all" />
                                </div>
                                <div class="ns-products-inner">
                                    {products.hits.map((hit) => (
                                        <AutocompleteElement hit={hit} key={hit.id}>
                                            <AutocompleteElementContent hit={hit} isMobile={isMobile} />
                                        </AutocompleteElement>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <>
                        <h3 class="ns-ac-no-result-text">
                            No results for '{document.querySelector("input#search-input")?.value || "your search"}'
                        </h3>
                        <br></br>
                        <div class="nosto_element" id="searchdropdown-nosto-empty"></div>
                    </>
                )}
            </div>

            {isOpen && (
                <div onClick={closeAutocomplete} class="ns-dark-overlay-d"></div>
            )}
        </div>
    );
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}